import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { DashboardWidgetView } from "./DashboardWidgetView";
import { DashboardWidgetViewStore } from "../../store/DashboardWidgetViewStore";
import { useStore } from "../../../../hooks";

export const DashboardWidgetViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/dashboardWidget/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new DashboardWidgetViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <DashboardWidgetView dashboardWidgetViewStore={store} />
      </PageLayout>
    </div>
  );
});
